import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-operateLog",
  "use": "icon-operateLog-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-operateLog\"><path d=\"M905.984 344.704l-225.728-225.152L770.816 29.184l225.664 225.152z m-452.736 451.52L227.52 571.072l407.488-406.4 225.664 225.216z m181.504-451.136L408.384 570.816l45.12 44.8 226.368-225.664z m-226.816 496.32l-206.784-25.6-19.2-199.488zM128 896h768V512h128v512H0V0h576v128H128v768z\" p-id=\"8867\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol